import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldSchemesCopyRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-schemes-copy',
	path: '/secure/admin/ViewCopyFieldScreenScheme.jspa',
};
